(function () {
    'use strict';

    angular.module("imApp").factory("docPackTypeMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 3284,
                    parameters: parms || {}
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 3287,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
